import { render } from "./ColumnGallerySection.vue?vue&type=template&id=22437b8e"
import script from "./ColumnGallerySection.vue?vue&type=script&lang=js"
export * from "./ColumnGallerySection.vue?vue&type=script&lang=js"

import "./ColumnGallerySection.vue?vue&type=style&index=0&id=22437b8e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__